module.exports = "../images/walleye.jpg?v=b9081ab";